import { useLocation } from "react-router-dom";

const PORTRAIT_IMG =
  "https://customer-assets.emergentagent.com/job_metamorph-saga/artifacts/f3ltvl6r_250814_GEORGE_MAPLE_0668.jpg";

/*
 * BackdropPortrait — translucent George Maple portrait over a deep navy
 * canvas, with a breathing "key light" that expands and contracts as if
 * the orb is illuminating the image. Hidden on the landing.
 */
export default function BackdropPortrait() {
  const { pathname } = useLocation();
  // Hide on landing (it has its own hero) and on all /admin pages so the
  // back-office stays clean and readable.
  if (pathname === "/" || pathname.startsWith("/admin")) return null;

  return (
    <div className="backdrop-portrait" aria-hidden>
      <img src={PORTRAIT_IMG} alt="" />
      <div className="backdrop-portrait-wash" />
      <div className="backdrop-keylight" />
    </div>
  );
}
